import type { ReactNode } from 'react'
import s from './UebersichtSpalte.module.scss'

/**
 * Eine Spalte der Übersicht: Positiv, Negativ oder Fällig.
 *
 * Der Kopf trägt die Farbe des Vorzeichens als Unterstrich und die Zahlen:
 * wie viele Einträge, wie viele davon neu (oder überfällig). Der Körper
 * scrollt in sich, damit drei Spalten nebeneinander gleich hoch bleiben.
 */
export function UebersichtSpalte({ titel, ton, anzahl, nebenzahl, leer, fuss, children }: {
  titel: string
  /** good für Positiv, bad für Negativ, neutral für Fällig. */
  ton: 'good' | 'bad' | 'neutral'
  anzahl: number
  /** Rechts neben der Anzahl, etwa „3 neu" oder „1 überfällig". */
  nebenzahl?: ReactNode
  /** Was bei leerer Spalte steht. */
  leer: string
  /** Links unter der Liste, etwa „Alle Aufgaben · Kalender". */
  fuss?: ReactNode
  children?: ReactNode
}) {
  const leerBleibt = anzahl === 0
  return (
    <section className={s.spalte}>
      <div className={s.kopf} data-ton={ton}>
        <h2 className={s.titel}>{titel}</h2>
        <div className={s.zahlen}>
          <strong>{anzahl}</strong>
          {nebenzahl && <> · {nebenzahl}</>}
        </div>
      </div>
      <div className={s.rollen}>
        {leerBleibt ? <div className={s.leer}>{leer}</div> : children}
      </div>
      {fuss && <div className={s.fuss}>{fuss}</div>}
    </section>
  )
}
